import { Reducer } from 'redux';
import { NotificationsState, NotificationsActions, NotificationsActionTypes } from './notifications.types';

const initialState: NotificationsState = {
    notifications: []
};

export const notificationsReducer: Reducer<NotificationsState, NotificationsActions> = (state = initialState, action) => {
    switch (action.type) {
        case NotificationsActionTypes.ADD_NOTIFICATION: {
            return { ...state, notifications: [...state.notifications, action.notification] };
        }

        case NotificationsActionTypes.REMOVE_NOTIFICATION: {
            return { ...state, notifications: state.notifications.filter(notification => notification.id !== action.id) };
        }

        default: {
            return state;
        }
    }
};